export default __webpack_public_path__ + "static/SR USA - Hoja de Seguridad - Color Caramelo (Liquido)-9e42469effb2852f31f0a512e01fcff5.pdf";